// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Q8lf","left":"InfoRow_left__2bMjy"};